import { connect } from 'react-redux';
import {
  removeDealMembers,
  removeDealTeams,
  addDealMembers,
  addDealTeams,
  addManageDealTeams,
  addCommissionMembers,
  removeCommissionMembers,
  addCommissionTeams,
  removeCommissionTeams,
  addAllAdminDealMembers,
  removeAdminDealMembers,
  removeAdminDealTeams,
  addAllAdminCommissionMembers,
  removeAdminCommissionMembers
} from '../../redux/actions/team-members-actions';
import { addRecipients } from '../../redux/actions/voucher/voucher-actions';
import DealTeamModal from './deal-team-modal';

const mapStateToProps = state => ({
  deal: state.deal.deal || {},
  dealUsers: state.teamMembers.dealUsers || [],
  dealTeams: state.teamMembers.dealTeams || [],
  relatedTransactionUsers: state.teamMembers.relatedTransactionUsers || [],
  relatedTransactionTeams: state.teamMembers?.relatedTransactionTeams || [],
  user: state.userData.data || {},
  adminManageDeal: state.admin?.adminManageDeal || {},
  userFlag: state.teamMembers.user || "",
});

const mapDispatchToProps = ({
  addDealMembers,
  addAllAdminDealMembers,
  addCommissionMembers,
  addAllAdminCommissionMembers,
  addDealTeams,
  addCommissionTeams,
  addRecipients,
  removeDealMembers,
  removeCommissionMembers,
  removeAdminCommissionMembers,
  removeDealTeams,
  removeCommissionTeams,
  removeAdminDealMembers,
  addManageDealTeams,
  removeAdminDealTeams
});

const DealDetailTeamModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DealTeamModal);

export default DealDetailTeamModalContainer;
